import classNames from 'classnames'

import Typography from '~/components/Typography'

import styles from './FarmInfo.pcss'

interface Props {
	children: React.ReactNode
	className?: string
	title: string
	href?: string
}

function FarmInfo({ className, title, children, href }: Props) {
	return (
		<div className={classNames(styles.container, className)}>
			<Typography className={styles.title}>
				{href ? (
					<a href={href} target="_blank" rel="noopener noreferrer">
						{title}
					</a>
				) : (
					title
				)}
			</Typography>
			<Typography>{children}</Typography>
		</div>
	)
}

export default FarmInfo
